import { WorkerAction } from '../framework/workerAction';

export default {
  export: {
    feedback: new WorkerAction({ name: 'TRACK_EXPORT_REDIRECT_FEEDBACK' }, {}),
  },
};
